import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_status_checkbox_checked_all_normal",
  "use": "icon-icon_status_checkbox_checked_all_normal-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-icon_status_checkbox_checked_all_normal\">\n<rect x=\"3\" y=\"3\" fill=\"#2986FF\" width=\"14\" height=\"14\" />\n<rect x=\"4.5\" y=\"9\" fill=\"#FFFFFF\" width=\"11\" height=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol